export default __webpack_public_path__ + "static/media/bg5.9e3d2ac8.jpg";